import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormArray, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { EducationLevels } from '../../enums/enums';
import { enumToArrOfObjs } from '../../helpers/helpers';
import { CvFormHelperService } from '../../services/cv-form-helper.service';
import { CvService } from '../../services/cv.service';

@Component({
  selector: 'bwc-shared-profile',
  templateUrl: './shared-profile.component.html',
  styleUrls: ['./shared-profile.component.scss'],
})
export class SharedProfileComponent implements OnInit {
  form: UntypedFormGroup;
  levelOptions = enumToArrOfObjs(EducationLevels);
  dataLoaded = false;

  expandedSections: Record<string, boolean> = {
    soft_skills: true,
    knowledge_skills: true,
    work_history: true,
    education: true,
    languages: true,
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cvService: CvService,
    private cvFormHelper: CvFormHelperService,
    private location: Location
  ) {
    this.form = new UntypedFormGroup({
      first_name: new UntypedFormControl(''),
      last_name: new UntypedFormControl(''),
      email: new UntypedFormControl(''),
      phone: new UntypedFormControl(''),
      photo: new UntypedFormControl(''),
      photo_id: new UntypedFormControl(''),
      city: new UntypedFormControl(''),
      country: new UntypedFormControl(''),
      birthday: new UntypedFormControl(''),
      gender: new UntypedFormControl(''),
      soft_skills: new UntypedFormArray([]),
      knowledge_skills: new UntypedFormArray([]),
      task_skills: new UntypedFormArray([]),
      professional_skills: new UntypedFormArray([]),
      it_skills: new UntypedFormArray([]),
      skills: new UntypedFormArray([]),
      work_history: new UntypedFormArray([]),
      education: new UntypedFormArray([]),
      languages: new UntypedFormArray([]),
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const uid = params['uid'];
      if (!uid) {
        this.router.navigate(['/login']);
        return;
      }
      this.loadSharedCv(uid);
    });
  }

  goBack(): void {
    this.location.back();
  }

  toggleSection(section: string): void {
    this.expandedSections[section] = !this.expandedSections[section];
  }

  isSectionExpanded(section: string): boolean {
    return this.expandedSections[section] ?? true;
  }

  get softSkills(): FormArray {
    return this.form.get('soft_skills') as FormArray;
  }

  get knowledgeSkills(): FormArray {
    return this.form.get('knowledge_skills') as FormArray;
  }

  get education(): FormArray {
    return this.form.get('education') as FormArray;
  }

  get languages(): FormArray {
    return this.form.get('languages') as FormArray;
  }

  get work_history(): FormArray {
    return this.form.get('work_history') as FormArray;
  }

  private loadSharedCv(userId: string): void {
    this.cvService.getCVbyId(userId).subscribe({
      next: (data) => {
        this.form.patchValue({
          first_name: data.first_name,
          last_name: data.last_name,
          email: data.email,
          phone: data.phone_number,
          city: data.city,
          country: data.country,
          birthday: data.birth_date,
          gender: data.gender,
        });
        this.cvFormHelper.patchUserPhoto(this.form, data);
        this.cvFormHelper.populateFormArraysFromCv(data, {
          softSkills: this.softSkills,
          knowledgeSkills: this.knowledgeSkills,
          profSkills: this.form.get('professional_skills') as FormArray,
          taskSkills: this.form.get('task_skills') as FormArray,
          itSkills: this.form.get('it_skills') as FormArray,
          education: this.education,
          languages: this.languages,
          workHistory: this.work_history,
        }, true);
        this.dataLoaded = true;
      },
      error: (err) => {
        console.error('Error loading shared CV:', err);
        this.router.navigate(['/login']);
      },
    });
  }
}
